<template>
  <div class="mini-member">
    <div class="mini-member__avatar">
      <div class="mini-member__avatar-image">
        <img :src="dialogAvatar" />
      </div>
    </div>
    <div class="mini-member__name">
      {{dialogTitle}}
    </div>
  </div>
</template>

<script>
import dialogUtils from '@/mixins/dialogUtils'

export default {
  name: 'MiniMember',
  mixins: [dialogUtils],
  props: {
    dialog: Object,
  },
  computed: {
    user() {
      return null;
    }
  }
}
</script>

<style lang="scss">
.mini-member {
  display: flex;
  align-items: center;
  padding: 6px 12px;
  cursor: pointer;

  &:hover {
    background: #F0F3F7;
  }

  &__avatar {
    position: relative;
    flex: 0 0 20px;
    max-width: 20px;
  }

  &__avatar-image {
    position: relative;
    z-index: 1;
    width: 20px;
    height: 20px;
    border-radius: 5px;
    background: #f4f4f4;
    overflow: hidden;
    img {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      object-fit: cover;
      object-position: center top;
    }
  }

  &__name {
    font-size: 15px;
    font-weight: 400;
    line-height: 23.63px;
    color: #474747;

    margin-left: 8px;
  }
}
</style>
